import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-management-main-panel-title',
    templateUrl: './management-main-panel-title.component.html',
})
export class ManagementMainPanelTitleComponent {
    public readonly icon = input<IconProp>();
    public readonly title: InputSignal<string> = input.required<string>();
}
